var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('symbol',{attrs:{"id":(_vm.prefix + "arrow_corner-12"),"viewBox":"0 0 12 8"}},[_c('path',{staticClass:"sign arrow",attrs:{"d":"M1 1.5L6 6.5L11 1.5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }